import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsBadgeNormalLarge = React.forwardRef(
  ({ color = "currentColor", size = 48, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M24 8.533l8 4.461v9.012l-8 4.462-8-4.462v-9.012zm-5 6.223v5.488l5 2.789 5-2.789v-5.488l-5-2.788z" />
        <path d="M21.28.822a5.5 5.5 0 015.44 0l10.5 5.974a5.5 5.5 0 012.78 4.78v11.848a5.5 5.5 0 01-2.78 4.78L36 28.9v15.48c0 2.936-3.399 4.567-5.69 2.73L24 42.049l-6.31 5.06c-2.291 1.837-5.69.206-5.69-2.73v-15.48l-1.22-.694A5.5 5.5 0 018 23.425V11.576a5.5 5.5 0 012.78-4.78zM15 30.606v13.772a.5.5 0 00.813.39L24 38.203l8.187 6.567a.5.5 0 00.813-.39V30.606l-6.28 3.573a5.5 5.5 0 01-5.44 0zM25.236 3.43a2.5 2.5 0 00-2.472 0l-10.5 5.974A2.5 2.5 0 0011 11.577v11.847a2.5 2.5 0 001.264 2.173l10.5 5.974a2.5 2.5 0 002.472 0l10.5-5.974A2.5 2.5 0 0037 23.424V11.577a2.5 2.5 0 00-1.264-2.173z" />
      </g>
    </svg>
  )
);
SvgAchievementsBadgeNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsBadgeNormalLarge;
